import React from 'react';
import { Space, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getUser } from 'selectors';
import { useSelector } from 'react-redux';

export default function User() {
  const { currentUser } = useSelector(getUser);

  console.log('currentUser', currentUser);

  return (
    <Space>
      <div>{currentUser && currentUser.name}</div>
      <Avatar shape="square" icon={<UserOutlined />} />
    </Space>
  );
}
